<script>
    import WPNSelector from "../Misc/WPNSelector.svelte";
    import { categoriesForAttribute } from "../../scripts/wpn2Edit.js";
    import { nextAvailableName } from "../../scripts/wpn2Model.js";
    import dbData from "../../Stores/utilityDBStore.js";

    export let selectedItem = null;
    let autoName = nextAvailableName(selectedItem["entity"], $dbData.all);
    let valName = selectedItem["name"];
    let valInstructions = selectedItem["instructions"];
    let valPriority = selectedItem["priority"];
    let valStatus = selectedItem["status"];
    let valProgram = selectedItem["wpn2_type"];

    // CSS Dropdowns: https://www.w3schools.com/howto/howto_css_dropdown.asp
    // Svelte select example: https://github.com/rob-balfre/svelte-select
    function dd1Changed(event) {
        console.log("Dropdown changed: ", event.detail);
        if (event.detail.name == "selPriority") {
            valPriority = event.detail.value;
        } else if (event.detail.name == "selStatus") {
            valStatus = event.detail.value;
        } else if (event.detail.name == "selProgram") {
            valProgram = event.detail.value;
        }
    }
</script>

<div class="edit-container">
    <div class="edit-section-title">Work Order</div>
    <form class="edit-form-inline">
        <div class="edit-col">
            <label class="edit-label" for="txtName">Reference or Name</label>
            <input
                class="edit-input"
                placeholder={autoName}
                type="text"
                bind:this={valName}
                name="txtName"
                autocomplete="off"
            />
        </div>
        <div class="edit-col" id="instructions-col">
            <label class="edit-label" for="txtInstructions">Instructions</label>
            <input
                class="edit-input"
                id="instructions-input"
                placeholder="Add instructions"
                type="text"
                bind:this={valInstructions}
                name="txtInstructions"
                autocomplete="off"
            />
        </div>
    </form>
    <form class="edit-form-inline">
        <div class="edit-col" id="priority-col">
            <label class="edit-label" for="selPriority">Priority</label>
            <WPNSelector
                selectorOptions={categoriesForAttribute('priority', selectedItem['entity'])}
                selectorName="selPriority"
                selected={valPriority}
                on:selector-changed={dd1Changed}
            />
        </div>
        <div class="edit-col" id="status-col">
            <label class="edit-label" for="selStatus">Status</label>
            <WPNSelector
                selectorOptions={categoriesForAttribute('status', selectedItem['entity'])}
                selectorName="selStatus"
                selected={valStatus}
                on:selector-changed={dd1Changed}
            />
        </div>
        <div class="edit-col" id="program-col">
            <label class="edit-label" for="selProgram">Program</label>
            <WPNSelector
                selectorOptions={categoriesForAttribute('wpn2_type', selectedItem['entity'])}
                selectorName="selProgram"
                selected={valProgram}
                on:selector-changed={dd1Changed}
            />
        </div>
    </form>
</div>

<style>
    #instructions-col {
        width: calc(100% - 330px);
    }
    #instructions-input {
        width: 90%;
    }
    #priority-col,
    #status-col,
    #program-col {
        width: 256px;
    }
</style>
